import TripAdvisorCircle from 'features/Engagement/TripAdvisorRating/TripAdvisorCircle'

const RatingBubbles = ({ rating }) => {
  const filledBublesCount = Math.floor(rating)
  const emptyBubblesCount = 5 - Math.ceil(rating)
  const halfBubblesCount = 5 - filledBublesCount - emptyBubblesCount

  return (
    <div style={{ display: 'flex', width: 85, justifyContent: 'space-between' }}>
      {Array(filledBublesCount)
        .fill('')
        .map((v, i) => (
          <TripAdvisorCircle type="full" key={i} />
        ))}
      {Array(halfBubblesCount)
        .fill('')
        .map((v, i) => (
          <TripAdvisorCircle type="halfFull" key={i} />
        ))}
      {Array(emptyBubblesCount)
        .fill('')
        .map((v, i) => (
          <TripAdvisorCircle type="empty" key={i} />
        ))}
    </div>
  )
}

export default RatingBubbles
